/**
 * Slide element up.
 *
 * @param {Object} element Target element.
 * @param {number} duration Animation duration.
 * @param {Function} callback Callback function.
 */
export const slideElementUp = (element, duration = 300, callback = null) => {
  element.style.height = `${element.scrollHeight}px`;
  element.offsetHeight; // Force reflow
  element.style.transitionProperty = "height";
  element.style.transitionDuration = `${duration}ms`;
  element.style.height = "0px";

  setTimeout(() => {
    element.style.display = "none";
    element.style.height = null;
    element.style.transitionProperty = "";
    element.style.transitionDuration = "";
    if (callback) {
      callback();
    }
  }, duration);
};

// new Accordion
document.addEventListener("DOMContentLoaded", function () {
  const accordions = document.querySelectorAll(".accordion-trigger");

  accordions.forEach((trigger) => {
    const panel = document.getElementById(
      trigger.getAttribute("aria-controls")
    );
    panel.style.height = "0px"; // Initialize with zero height
    panel.hidden = true; // Keep panel initially hidden

    trigger.addEventListener("click", function () {
      const expanded = this.getAttribute("aria-expanded") === "true" || false;

      // Toggle aria-expanded
      this.setAttribute("aria-expanded", !expanded);

      if (!expanded) {
        panel.hidden = false; // Show the panel
        const panelHeight = panel.scrollHeight; // Get the natural height
        panel.style.height = panelHeight + "px"; // Set the height to open it

        panel.addEventListener(
          "transitionend",
          function () {
            panel.style.height = "auto"; // After transition, set height to auto
          },
          { once: true }
        );
      } else {
        panel.style.height = panel.scrollHeight + "px"; // Set the current height
        setTimeout(() => {
          panel.style.height = "0px"; // Animate to close
        }, 10); // Small delay to ensure transition happens

        panel.addEventListener(
          "transitionend",
          function () {
            panel.hidden = true; // After animation, hide the panel
          },
          { once: true }
        );
      }
    });
  });
});

document.addEventListener("DOMContentLoaded", function () {
  const toggleButton = document.querySelector(".xoo-el-section"); // The button that toggles between login/signup
  const loginContent = document.getElementById("login-content");
  const signupContent = document.getElementById("signup-content");

  // Check if toggleButton exists on the page
  if (!toggleButton || !loginContent || !signupContent) {
    return; // Exit the function if toggleButton or content elements are not found
  }

  // Function to update content display based on toggle button's class
  function updateContent() {
    if (toggleButton.classList.contains("xoo-el-active")) {
      loginContent.style.display = "block";
      signupContent.style.display = "none";
    } else {
      loginContent.style.display = "none";
      signupContent.style.display = "block";
    }
  }

  // Initial display update on page load
  updateContent();

  // Observe changes in the class attribute of the toggle button
  const observer = new MutationObserver(updateContent);
  observer.observe(toggleButton, {
    attributes: true,
    attributeFilter: ["class"],
  });
});

// Wait for the DOM to be ready
// Wait for the DOM to be ready
document.addEventListener("DOMContentLoaded", function () {
  const observerOptions = {
    root: null,
    rootMargin: "0px",
    threshold: 0.1,
  };

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry, index) => {
      if (entry.isIntersecting) {
        // Add delay to all elements except the first one
        if (index !== 0) {
          entry.target.style.transitionDelay = `${index * 0.15}s`;
        }
        entry.target.classList.add("visible");
        // Once the animation is complete, we no longer need to observe this element
        observer.unobserve(entry.target);
      }
    });
  }, observerOptions);

  // Find all elements with the fade-in class
  const fadeElements = document.querySelectorAll(".fade-in");
  fadeElements.forEach((element) => {
    observer.observe(element);
  });
});

const reviewLink = document.querySelector(".woocommerce-review-link");

if (reviewLink) {
  reviewLink.addEventListener("click", function (event) {
    event.preventDefault();

    const target = document.querySelector("#reviews");
    const header = document.querySelector(".site-header");

    if (target && header) {
      const headerHeight = header.offsetHeight;
      const targetPosition = target.offsetTop - headerHeight;

      window.scrollTo({
        top: targetPosition,
        behavior: "smooth",
      });
    }
  });
}
